import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "@phosphor-icons/react";

const partnersBg = "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?crop=entropy&cs=srgb&fm=jpg&q=90&w=2400&fit=max";

export default function PartnersPage() {
    return (
        <div data-testid="partners-page" className="relative">
            <div className="grain" />

            {/* HERO */}
            <section className="relative min-h-[80vh] overflow-hidden">
                <div className="absolute inset-0 bg-cover bg-center opacity-30" style={{ backgroundImage: `url(${partnersBg})` }} />
                <div className="absolute inset-0 bg-gradient-to-b from-slate-950/70 via-slate-950/60 to-slate-950" />
                <div className="relative max-w-6xl mx-auto px-6 sm:px-10 pt-28 pb-20">
                    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="label-eyebrow mb-6">
                        <span className="text-gold">/</span> Become a Butler Partner
                    </motion.div>
                    <motion.h1 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, delay: 0.05 }} className="text-5xl sm:text-6xl lg:text-7xl font-serif leading-[1.05] tracking-tight max-w-3xl">
                        For <span className="italic gold-text">white-glove</span> service professionals.
                    </motion.h1>
                    <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.8, delay: 0.15 }} className="mt-6 text-slate-300 text-lg max-w-2xl leading-relaxed">
                        Independent 1099 professionals only. We invite a select group of vetted Butler Partners to serve discerning Central Florida homes.
                    </motion.p>
                    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.8, delay: 0.25 }} className="mt-10 flex flex-wrap gap-3">
                        <Link to="/partners/apply" data-testid="apply-cta" className="btn-gold inline-flex items-center gap-2">
                            Apply now <ArrowRight size={16} weight="bold" />
                        </Link>
                    </motion.div>
                </div>
            </section>

            {/* TERMS section removed Feb 2026 — pivoted away from membership/lead-marketplace model.
                 Contractor terms (1099, payout, scheduling, etc.) live in the signed Independent
                 Contractor Referral Agreement at /legal and inside the application flow. */}

            {/* CTA */}
            <section className="py-24 border-t border-white/5">
                <div className="max-w-3xl mx-auto px-6 text-center">
                    <h2 className="text-4xl sm:text-5xl font-serif">
                        Ready to <span className="italic gold-text">join</span>?
                    </h2>
                    <p className="mt-4 text-slate-400">Apply now — takes 3 minutes. You'll sign the agreement online; we'll review and follow up within 2 business days.</p>
                    <div className="mt-8">
                        <Link to="/partners/apply" data-testid="apply-cta-2" className="btn-gold inline-flex items-center gap-2">
                            Start the application <ArrowRight size={16} weight="bold" />
                        </Link>
                    </div>
                </div>
            </section>

            <footer className="border-t border-white/5 py-10 px-6 text-center text-slate-500 text-sm">
                © The Butler Room — Premium home concierge.
            </footer>
        </div>
    );
}
